type NoPermissionProps = {
  userName: string
}

const NoPermission = ({userName}: NoPermissionProps) => {
    return (
      <>
        <div className="error-container">
          <div className="text-center mt-5">
            <h2 className="text-warning">No Report Permissions</h2>
            <h3>
              <i className="fas fa-exclamation-triangle text-warning" />{" "}
              No report permissions found for "{userName}"
            </h3>
          </div>
        </div>
      </>
    );
  };
  
  export default NoPermission;
  